import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const getById = async id => (await request.getInstance()).get(`${API_ROUTES.questionsThemes.getThemeById.replace(':id', id)}`);
export const getAll = async () => (await request.getInstance()).get(`${API_ROUTES.questionsThemes.getAllThemes}`);
export const addTheme = async data => (await request.getInstance()).post(`${API_ROUTES.questionsThemes.addTheme}`, data);
export const changeTheme = async (id, data) => (await request.getInstance()).put(`${API_ROUTES.questionsThemes.getThemeById.replace(':id', id)}`, data);
export const deleteTheme = async id => (await request.getInstance()).delete(`${API_ROUTES.questionsThemes.getThemeById.replace(':id', id)}`);
